import React from 'react';
import Paragraph from 'app_previous/elements/typography/paragraph';
import IdealMembersWithButtonInput from '../../NameGenerator/IdealMembersInput/IdealMembersInputWithButton';
import { InlineGeneratorInputContainer } from './InlineGeneratorInput.styles';
import GeneratorMobileButton from '../../Shared/AiNameGeneratorHeader/GeneratorMobileButton';

interface InlineGeneratorInputProps {
  placeholder: string;
  helperText: string;
  inputError?: string;
  description?: string;
  setDescription?: (description: string) => void;
  handleSubmit?: () => void;
  helperTextColor?: string;
  buttonColor?: string;
  buttonBorderColor?: string;
}

const InlineGeneratorInput = ({
  helperText,
  placeholder,
  description,
  inputError,
  setDescription,
  handleSubmit,
  helperTextColor,
  buttonColor,
  buttonBorderColor,
}: InlineGeneratorInputProps): JSX.Element => {
  return (
    <InlineGeneratorInputContainer>
      <IdealMembersWithButtonInput
        inputError={inputError}
        idealMember={description}
        setIdealMember={setDescription}
        handleIdealMemberSubmit={handleSubmit}
        placeholder={placeholder}
        buttonText='Generate'
        buttonColor={buttonColor}
        buttonBorderColor={buttonBorderColor}
      />
      <GeneratorMobileButton
        handleSubmit={handleSubmit}
        text='Generate'
        backgroundColor={buttonColor}
        borderColor={buttonBorderColor}
      />
      <Paragraph
        text={helperText}
        standardSize='1'
        sizeSm='0.875rem'
        weight='light'
        align='center'
        color={helperTextColor}
      />
    </InlineGeneratorInputContainer>
  );
};

export default InlineGeneratorInput;
